import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { Container, Box, ThemeProvider } from '@mui/material';
import { Header, Footer, Logo, horwathTheme, NavigationItem, FooterColumn } from '@horwath-htl/shared-branding';
import HomePage from './pages/HomePage';
import DocumentUploadPage from './pages/DocumentUploadPage';

const App: React.FC = () => {
  const navigate = useNavigate();

  const navigationItems: NavigationItem[] = [
    { label: 'Home', onClick: () => navigate('/') },
    { label: 'About', onClick: () => navigate('/about') },
    { label: 'Services', onClick: () => navigate('/services') },
    { label: 'Experience', onClick: () => navigate('/experience') },
    { label: 'Insights', onClick: () => navigate('/insights') },
    { label: 'Contact', onClick: () => navigate('/contact') },
  ];

  const footerColumns: FooterColumn[] = [
    {
      title: 'Company',
      links: [
        { label: 'About Us', onClick: () => navigate('/about') },
        { label: 'Our Team', onClick: () => navigate('/team') },
        { label: 'Careers', onClick: () => navigate('/careers') },
      ],
    },
    {
      title: 'Services',
      links: [
        { label: 'Hotel Consulting', onClick: () => navigate('/services/hotel') },
        { label: 'Tourism Advisory', onClick: () => navigate('/services/tourism') },
        { label: 'Market Research', onClick: () => navigate('/services/research') },
      ],
    },
    {
      title: 'Resources',
      links: [
        { label: 'Insights', onClick: () => navigate('/insights') },
        { label: 'Publications', onClick: () => navigate('/publications') },
        { label: 'News', onClick: () => navigate('/news') },
      ],
    },
  ];

  const contactInfo = {
    title: 'Contact Us',
    address: ['123 Business Avenue', 'New York, NY 10001', 'United States'],
    phone: '+1 (212) 555-0100',
    email: 'info@horwathhtl.com',
  };

  return (
    <ThemeProvider theme={horwathTheme}>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header
          logo={<Logo />}
          navigationItems={navigationItems}
          onLogoClick={() => navigate('/')}
        />
        
        <Container component="main" sx={{ flexGrow: 1, py: 3 }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<div>About Page</div>} />
            <Route path="/services" element={<div>Services Page</div>} />
            <Route path="/experience" element={<div>Experience Page</div>} />
            <Route path="/insights" element={<div>Insights Page</div>} />
            <Route path="/contact" element={<div>Contact Page</div>} />
            <Route path="/document-upload" element={<DocumentUploadPage />} />
          </Routes>
        </Container>
        
        <Footer
          logo={<Logo color="white" />}
          navigationColumns={footerColumns}
          contactInfo={contactInfo}
          privacyPolicyLink="/privacy"
          apiUrl={import.meta.env.VITE_API_URL || 'http://localhost:7071'}
        />
      </Box>
    </ThemeProvider>
  );
};

export default App;
